import { render, staticRenderFns } from "./pagePart5.vue?vue&type=template&id=804ea3c4&scoped=true"
import script from "./pagePart5.vue?vue&type=script&lang=js"
export * from "./pagePart5.vue?vue&type=script&lang=js"
import style0 from "./pagePart5.vue?vue&type=style&index=0&id=804ea3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804ea3c4",
  null
  
)

export default component.exports